import axios from "axios";
import Storage from "../../utils/Storage";
import Config from "../../config";
import qs from "qs";
import { CheckboxValueType } from "antd/es/checkbox/Group";

export interface EvaCourseListItem {
    evaluationId: number; // 评教id
    batchNo: string; // 学期
    courseName: string; // 课程名
    flag: boolean; // 是否评教 0 否 1 是
    teacherName: string; // 授课教师
    courseNo: string; // 课编号
    courseSeq: string; // 课序号
    teacherNo: string; // 教师编号
}
export interface EvaCourseListProps {
    list: EvaCourseListItem[];
    names: string;
    flag: BooleanValue;
}
export function evaluationCourseList() {
    const batchNo = Storage.get("batch") || Config.DefaultBatch;

    return axios
        .post<SuccessData<EvaCourseListProps>>(
            "/teacher/evaluation/evaluationCourseList",
            qs.stringify({ batchNo })
        )
        .then(res => {
            return (
                res?.data?.data || {
                    data: {
                        data: {
                            list: [],
                            names: "",
                            flag: "0"
                        }
                    }
                }
            );
        });
}

export interface Ans {
    id: string;
    stuAns: string;
    stuText?: string;
}

export interface TopicsItem {
    index: number;
    contentText: string; //标题
    id: string;
    queTypeId: string; //queTypeId 1,2,3,4,5,6:阅读理解（6以上都有可能多题干）
    typeName: string; //题类型名
    options: OptionItem[];
    zbx: string; //指标项
    stuAns: string;
    stuAnsList: Ans[];
    stuAnsMap: Map<string, { id: string; text: string }>;
}

export enum EvaluateCan {
    no = "0",
    Yes = "1"
}

export interface OptionItem {
    description: string;
    id: string;
    score: string;
    ckdesc: string;
    text?: EvaluateCan;
}

//评教状态
export enum evaluationStatus {
    "NotEvaluated" = "0", //有评教，未经评教
    "Evaluated" = "1", //有评教，已进行评教
    "EvaluationIsNull" = "2" //无评教
}

//题型
export enum evaluationType {
    "radio" = "1",
    "checkbox" = "2",
    "textarea" = "4",
    "radioText" = "a"
}

//题目类别
export enum evaluationGroupType {
    One = "1",
    Many = "2"
}

export interface RadioEventProps {
    onSave: (value: string) => void;
    onChange?: (value: string) => void;
    value?: string | number;
}

export interface CheckboxEventProps {
    onSave: (value: any) => void;
    onChange?: (value: CheckboxValueType[]) => void;
    value?: string[];
}

export interface TextareaEventProps {
    onSave: (value: any) => void;
    onChange?: (value: any) => void;
    value?: string;
}

//学生是否有未完成的评教
export function getTeacherEvaluationStatus() {
    return axios
        .get(`/teacher/evaluation/studentEvaluationStatus`)
        .then(res => res.data.data);
}

//评教详情
export interface getTeaEvlProps {
    evaluationId: string;
}

export interface EvlTeacherInfoProps {
    courseName: string;
    teacherName: string;
    courseNo: string;
    courseSeq: string;
    id: string;
}
export interface TeaEvlProps {
    topics: TopicsItem[];
    courseName: string;
    courseNo: string;
    courseSeq: string;
    endTime: string;
    evaluationId: string;
    name: string;
    startTime: string;
    status: evaluationStatus;
    teacherName: string;
    evaluationList: EvlTeacherInfoProps[];
}
export function getTeacherEvaluation(data: getTeaEvlProps) {
    return axios
        .post<SuccessData<TeaEvlProps>>(
            `/teacher/evaluation/teacherEvaluation`,
            qs.stringify(data)
        )
        .then(res => res.data.data)
        .then(data => ({
            ...data,
            topics: data.topics.map((item: TopicsItem, index: number) => ({
                ...item,
                index: index + 1,
                stuAns:
                    item.queTypeId === evaluationType.checkbox
                        ? JSON.parse((item?.stuAns as string) || "[]")
                        : item.stuAns
            }))
        }));
}
//评教详情 一对多

export function getTeacherEvaluationMany(params: getTeaEvlProps) {
    return axios
        .get<SuccessData<TeaEvlProps>>(
            `/teacher/evaluation/studentEvaluation2`,
            {
                params
            }
        )
        .then(res => res.data.data)
        .then(data => ({
            ...data,
            topics: data.topics.map((item: TopicsItem, index: number) => {
                const stuAnsMap = new Map<
                    string,
                    { id: string; text: string }
                >();
                item.stuAnsList.forEach(AnsItem => {
                    stuAnsMap.set(AnsItem.id, {
                        id:
                            item.queTypeId === evaluationType.checkbox
                                ? JSON.parse(AnsItem?.stuAns || "[]")
                                : AnsItem.stuAns,
                        text: AnsItem?.stuText || ""
                    });
                });
                return {
                    ...item,
                    index: index + 1,
                    stuAnsMap
                    // stuAns:
                    //     item.queTypeId === evaluationType.checkbox
                    //         ? JSON.parse(item?.stuAns || "[]")
                    //         : item.stuAns
                };
            })
        }));
}

//保存单道
export interface saveTeacherAnswerProps {
    evaluationId: string;
    questionId: string;
    answer: string | string[];
}
export function saveTeacherAnswer(data: saveTeacherAnswerProps) {
    return axios
        .post(`/teacher/evaluation/saveTeacherAnswer`, qs.stringify(data))
        .then(data => data.data.data);
}

//提交
export interface SubEvaItemDataProps {
    evaluationId: string;
    id: string;
    value: string | undefined;
}
export interface submitEvaluationProps {
    evaluationId: string;
    data: SubEvaItemDataProps[];
}
export function submitEvaluation(data: submitEvaluationProps) {
    return axios
        .post(`/teacher/evaluation/submitEvaluation`, data, {
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            }
        })
        .then(data => data.data.data);
}
